import { createContext } from "react";

const ModalDialogContext = createContext({
  visible: false,
  title: "",
  message: "",
  onPressOk: null,
  onPressYes: null,
  onPressNo: null,
  onPressCancel: null,
  loading: false,
  status: "",
  yesLabel: "",
  noLabel: "",
  showModalDialog: () => {},
  hideModalDialog: () => {},
  showMessage: () => {},
  showErrorMessage: () => {},
  showLoadingMessage: () => {},
  showConfirmation: () => {},
});

export default ModalDialogContext;
